export enum RequestState {
    Idle = "idle",
    Requesting = "requesting",
    Processing = "processing",
}
